<!--
  绑定邮箱
  lovi 2020-07-08
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="
        flag == 2
          ? $t('common.retrievePassword')
          : $t('securitySet.emailBinding')
      "
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="scroll-wrapper logReg-field">
      <h3></h3>
      <ul>
        <li>
          <van-cell-group>
            <van-field
              clearable
              type="text"
              v-model="email"
              :readonly="flag == 1"
              :error="error.email ? true : false"
              @input="verifyEmail"
              :placeholder="$t('securitySet.enterEmailAddress')"
            />
          </van-cell-group>
        </li>
        <li v-if="flag == 0 || flag == 2">
          <van-cell-group>
            <van-field
              class="van-field-code"
              clearable
              v-model="code"
              :error="error.code ? true : false"
              @input="verifyCode"
              :placeholder="$t('common.enterVerificationCode')"
            >
              <div slot="button">
                <van-count-down
                  class="text-orange"
                  v-if="countDownFlag"
                  :time="60000"
                  :format="$t('common.remaining') + 'ss s'"
                  @finish="finished"
                />
                <span v-else class="text-orange" @click="sendMailCode">
                  {{
                    againFlag ? $t("common.getAgain") : $t("common.getItNow")
                  }}
                </span>
              </div>
            </van-field>
          </van-cell-group>
        </li>
        <p v-if="flag == 1" class="tips text-gray">
          {{ $t("securitySet.emailResetPsdTips") }}
        </p>
        <li>
          <van-button round type="primary" block @click="submit">
            {{ flag == 1 ? $t("common.removeBinding") : $t("common.confirm") }}
          </van-button>
        </li>
      </ul>
    </div>
    <transition name="slide">
      <pay-psd
        v-if="payPsdFlag"
        :payPsdFlag.sync="payPsdFlag"
        parentPage="verify"
        @getPayPsd="getPayPsd"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as validate from "@/commonJs/validate.js";
import PayPsd from "@/views/common/payPsd";
export default {
  props: ["emailFlag", "username"],
  name: "email",
  meta: {
    service: false // 客服
  },
  components: {
    PayPsd
  },
  data() {
    return {
      flag: 0, // 0未绑定 1已绑定 2找回密码
      type: 8, // 8邮箱绑定 10邮箱重置登录密码
      email: "",
      code: "",
      error: {
        email: false,
        code: false
      },
      countDownFlag: false, // 倒计时
      againFlag: false, // 重新获取短信验证码
      payPsdFlag: false,
      payPsd: ""
    };
  },
  created() {
    if (this.emailFlag) {
      this.flag = 2;
      this.type = 10;
    }
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    navBarBack() {
      // 返回
      if (this.emailFlag) {
        this.$emit("update:emailFlag", false);
      } else {
        this._back();
      }
    },
    verifyEmail() {
      // 验证邮箱
      this.error.email = validate.validateEmail(this.email);
    },
    verifyCode() {
      // 验证码
      this.error.code = validate.validateCode(this.code);
    },
    finished() {
      // 倒计时结束
      this.countDownFlag = false;
      this.againFlag = true;
    },
    getPayPsd(data) {
      // 获取支付密码
      console.log("getPayPsd", data);
      this.payPsd = data;
      this.mailBind();
    },
    sendMailCode() {
      // 发送邮箱验证码
      let vm = this;
      if (vm.email == "") {
        vm.$toast(vm.$t("securitySet.enterEmailAddress"));
        return false;
      }
      console.log(vm.error);
      if (vm.error.email) {
        vm.$toast(vm.error.email);
        return false;
      }
      let params = {};
      params.email = vm.email;
      params.type = vm.type;
      if (vm.type == 10) {
        params.username = vm.username;
      }
      vm.$post("/app/captcha/sendMailCode", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("sendMailCode", res);
        if (res.code == 0) {
          vm.countDownFlag = true;
        } else {
          vm.$toast(res.msg);
        }
      });
    },
    submit() {
      let vm = this;
      if (vm.flag == 1) {
        // 解除绑定
        vm.$dialog
          .confirm({
            message: vm.$t("common.sureRemoveBinding")
          })
          .then(() => {
            // on confirm
            vm.emailUnbundling();
          })
          .catch(() => {
            // on cancel
          });
        return false;
      }
      if (vm.email == "") {
        vm.$toast(vm.$t("securitySet.enterEmailAddress"));
        return false;
      }
      if (vm.code == "") {
        vm.$toast(vm.$t("common.enterVerificationCode"));
        return false;
      }
      for (let key in vm.error) {
        if (vm.error[key]) {
          vm.$toast(vm.error[key]);
          return false;
        }
      }
      vm.validateEmailCode();
    },
    validateEmailCode() {
      // 验证邮箱
      let vm = this;
      let params = {};
      params.type = vm.type;
      params.email = vm.email;
      params.code = vm.code;
      vm.$post("/app/captcha/validateEmailCode", params, {
        loading: true
      }).then(res => {
        console.log("validateEmailCode", res);
        if (vm.emailFlag) {
          let obj = {};
          obj.email = vm.email;
          obj.code = vm.code;
          vm.$emit("getEmail", obj);
          vm.$emit("update:emailFlag", false);
          vm.$emit("update:setPsdFlag", true);
          return;
        }
        if (vm.payPsd == "") {
          // 验证支付密码
          vm.payPsdFlag = true;
          return;
        }
      });
    },
    mailBind() {
      // 绑定邮箱
      let vm = this;
      if (vm.email == "") {
        vm.$toast(vm.$t("securitySet.enterEmailAddress"));
        return false;
      }
      if (vm.code == "") {
        vm.$toast(vm.$t("common.enterVerificationCode"));
        return false;
      }
      for (let key in vm.error) {
        if (vm.error[key]) {
          vm.$toast(vm.error[key]);
          return false;
        }
      }
      if (vm.payPsd == "") {
        // 验证支付密码
        vm.payPsdFlag = true;
        return;
      }
      let params = {};
      params.email = vm.email;
      params.code = vm.code;
      params.pay_password = vm.payPsd;
      vm.$post("/app/user/mailBind", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("mailBind", res);
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm.flag = 1;
          vm.$store.dispatch("GET_USER_INFO");
        }
      });
    },
    emailUnbundling() {
      // 解除绑定
      let vm = this;
      vm.$post(
        "/app/user/emailUnbundling",
        {},
        {
          loading: true,
          alert: true
        }
      ).then(res => {
        console.log("emailUnbundling", res);
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm._back();
          vm.$store.dispatch("GET_USER_INFO");
        }
      });
    }
  },
  watch: {
    userInfo: {
      handler(obj) {
        if (obj.email) {
          this.flag = 1;
          this.email = obj.email;
        } else {
          this.flag = 0;
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
.tips {
  margin-top: 10px;
}
</style>
